import { render, staticRenderFns } from "./PlanMovil.vue?vue&type=template&id=2b6bd16a&scoped=true"
import script from "./PlanMovil.vue?vue&type=script&lang=js"
export * from "./PlanMovil.vue?vue&type=script&lang=js"
import style0 from "./PlanMovil.vue?vue&type=style&index=0&id=2b6bd16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bd16a",
  null
  
)

export default component.exports